import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'
import { AssignNumberStepsStore } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AssignNumber/store/assignNumberStore'

const AssignNumberStepsContext = createContext<AssignNumberStepsStore | null>(null)

export const useAssignNumberStepsContext = () => {
  const context = useContext(AssignNumberStepsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AssignNumberStepsContext')

  return context
}

export const AssignNumberStepsProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const inboxLayerStore = useInboxLayerContext()
  const store = useMemo(
    () => new AssignNumberStepsStore(inboxLayerStore, entities),
    [inboxLayerStore, entities]
  )

  useEffect(() => {
    store.init()

    return () => {
      store.dispose()
    }
  }, [store])

  return (
    <AssignNumberStepsContext.Provider value={store}>{children}</AssignNumberStepsContext.Provider>
  )
}
